<div>
    <div *ngIf="accountFound; else noAccountFound" style="overflow-y: auto">
        <table mat-table #accountsTable [dataSource]="dataSourceAccounts" style="width: 100%" matSort>
            <ng-container matColumnDef="AccountName">
                <div *ngIf="notChoosingListOfAccounts; else choosingListOfAccounts">
                    <th mat-header-cell *matHeaderCellDef>
                        <div style="display: flex; justify-content: space-between; padding-bottom: 1.2rem">
                            <div class="titleTabContent" style="justify-content: flex-start">
                                <span translate>M_SUB_INF_TITLE_TABLE</span>
                                <span> : {{ model.Description }}</span>
                            </div>
                            <div>
                                <button
                                    mat-flat-button
                                    color="primary"
                                    matTooltip="{{ 'M_ASSOCIATE_ACCOUNT' | translate }}"
                                    matTooltipClass="tooltip-layout"
                                    (click)="onClickShowAssociateAccount()"
                                    style="padding: 0 20px"
                                    class="button-icon-text"
                                >
                                    <mat-icon>add</mat-icon>
                                    <span style="padding: 0.2rem; font-size: 1rem" translate>M_SUB_INF_BTN_ASS</span>
                                </button>
                            </div>
                        </div>
                        <div
                            style="display: flex; justify-content: space-between; width: 100%; align-items: center; padding-bottom: 1.2rem"
                        >
                            <div class="searchFolder" style="width: 35%">
                                <div style="display: flex; width: 100%">
                                    <mat-icon matPrefix [inline]="true" class="m-r5" style="width: 5%"> search </mat-icon>
                                    <input
                                        matInput
                                        [(ngModel)]="searchAccountText"
                                        (keyup)="onClickApplyAccountSearch($event)"
                                        placeholder="{{ 'M_SEARCH_ACC' | translate }}"
                                    />
                                </div>
                                <div>
                                    <mat-icon matSuffix [inline]="true" class="cursor" (click)="clearAccountSearch()"> close </mat-icon>
                                </div>
                            </div>
                            <div class="searchFolder" style="padding: 0 20px; width: 18%">
                                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
                                    <div style="width: 100%">
                                        <mat-label translate>SUBSCRIPTIONS_ACCOUNTS.FILTER_BY </mat-label>
                                    </div>
                                    <div style="display: flex">
                                        <span class="material-icons"> filter_alt </span>
                                        <mat-select (selectionChange)="onClickDoSomething($event)">
                                            <mat-option value="ALL"><span translate>MANAGE_ACCOUNTS.OPT_1</span> </mat-option>
                                            <mat-option value="CO-USER-ADMIN"><span translate>ROLES_STRINGS.COUSERADMIN</span> </mat-option>
                                            <mat-option value="USER-ADMIN"><span translate>ROLES_STRINGS.USERADMIN </span> </mat-option>
                                            <mat-option value="POWER-USER"><span translate>ROLES_STRINGS.POWERUSER</span> </mat-option>
                                            <mat-option value="POWER-USER-SCHEDULER"
                                                ><span translate>ROLES_STRINGS.POWERUSERSCHED</span>
                                            </mat-option>
                                            <mat-option value="POWER-USER-REPORT"
                                                ><span translate>ROLES_STRINGS.POWERUSERREPORT</span>
                                            </mat-option>
                                            <mat-option value="SECURITY-ADMIN"
                                                ><span translate>ROLES_STRINGS.SECURITYADMIN</span>
                                            </mat-option>
                                            <mat-option value="APPLICATION-ADMIN"
                                                ><span translate>ROLES_STRINGS.APPLICADMIN</span>
                                            </mat-option>
                                        </mat-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </th>
                </div>
                <ng-template #choosingListOfAccounts>
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex-column align-center">
                            <div class="searchFolder">
                                <div style="display: flex; width: 100%">
                                    <mat-icon matPrefix [inline]="true" class="m-r5" style="width: 5%"> search </mat-icon>
                                    <input
                                        matInput
                                        [(ngModel)]="searchAccountText"
                                        (keyup)="onClickApplyAccountSearch($event)"
                                        placeholder="{{ 'M_SEARCH_ACC_FULLNAME_EMAIL' | translate }}"
                                    />
                                </div>
                                <div>
                                    <mat-icon matSuffix [inline]="true" class="cursor" (click)="clearAccountSearch()"> close </mat-icon>
                                </div>
                            </div>
                            <div
                                class="flex-space-between expirationDateAll"
                                *ngIf="dataSourceAccounts.data.length > 1 && dataSourceAccounts.filteredData.length !== 0"
                            >
                                <mat-checkbox
                                    (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                                >
                                    <span translate>M_SUB_SELECT_ALL_ACC</span>
                                </mat-checkbox>
                                <mat-form-field appearance="outline" style="margin: 0 !important; font-size: 12px !important">
                                    <mat-label translate>EDIT_SUBSCRIPTION.EXPIRATION_DATE</mat-label>
                                    <input
                                        matInput
                                        [min]="minDate"
                                        [matDatepicker]="aA"
                                        [(ngModel)]="value"
                                        (ngModelChange)="dateOnChange()"
                                        [ngModelOptions]="{ standalone: true }"
                                        name="ExpirationDate"
                                        readonly="true"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="aA"></mat-datepicker-toggle>
                                    <mat-datepicker #aA></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div *ngIf="dataSourceAccounts.data.length === 0">
                            <p translate>M_SUB_NO_ACC_TO_ASSOCIATE</p>
                        </div>
                        <div *ngIf="dataSourceAccounts.filteredData.length === 0" style="margin-top: 20px">
                            <p translate>M_SUB_ACC_NOT_FOUND</p>
                        </div>
                    </th>
                </ng-template>
                <div *ngIf="notChoosingListOfAccounts; else choosingListOfAccounts2">
                    <td mat-cell *matCellDef="let row" (click)="onClickChangeBackground(row.AccountName)">
                        <div style="display: flex; align-items: center; width: 100%">
                            <div style="display: flex; align-items: center; width: 30%; justify-content: flex-start">
                                <div style="display: flex; align-items: center">
                                    <div class="circleUserSmall bgGreenDark" style="margin: 0; margin-right: 10px">
                                        <span> {{ row.AccountName.trim().slice(0, 2).toLocaleUpperCase() }}</span>
                                    </div>
                                    <span>
                                        {{ row.AccountName }}
                                    </span>
                                </div>
                            </div>
                            <div style="display: flex; width: 40%; justify-content: flex-start; flex-wrap: wrap !important">
                                <div class="rolesLogin" *ngFor="let roles of row.ArrayRoles">
                                    <span>
                                        {{ roles }}
                                    </span>
                                </div>
                            </div>

                            <div style="display: flex; align-items: center; width: 30%; justify-content: flex-end">
                                <div style="display: flex; flex-direction: column; padding-right: 3rem">
                                    <span matTooltip="{{ 'EDIT_SUBSCRIPTION.DATE' | translate }}" matTooltipClass="tooltip-layout">
                                        {{ row.CreationDate | date : 'dd/MM/yyyy' }}
                                    </span>
                                    <span
                                        *ngIf="!row.willExpireIn100"
                                        matTooltip="{{ 'EDIT_SUBSCRIPTION.EXPIRATION_DATE' | translate }}"
                                        matTooltipClass="tooltip-layout"
                                        >{{ row.ExpirationDate | date : 'dd/MM/yyyy' }}</span
                                    >
                                </div>
                                <div style="display: flex; flex-direction: column" *ngIf="showTrash(row.AccountName)">
                                    <span
                                        matTooltip="{{ 'M_SUB_INF_TOOLTIP_2' | translate }}"
                                        matTooltipClass="tooltip-layout"
                                        (click)="onClickRemoveRow(row.AccountName)"
                                    >
                                        <mat-icon>delete_outline</mat-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                </div>
                <ng-template #choosingListOfAccounts2>
                    <td mat-cell *matCellDef="let row" style="background-color: white !important">
                        <mat-checkbox (click)="onClick($event)" (change)="onChange($event, row)" [checked]="selection.isSelected(row)">
                            <div class="flex-space-between">
                                <div style="display: flex; align-items: center">
                                    <div class="circleUserSmall bgGreenDark" style="margin: 0; margin-right: 10px">
                                        <span> {{ row.AccountName.trim().slice(0, 2).toLocaleUpperCase() }}</span>
                                    </div>
                                    <span matTooltip="{{ row.AccountName }}" class="dot">
                                        {{ row.AccountName }}
                                    </span>
                                </div>
                                <div>
                                    <mat-form-field appearance="outline" style="font-size: 12px !important">
                                        <mat-label translate>EDIT_SUBSCRIPTION.EXPIRATION_DATE</mat-label>
                                        <input
                                            matInput
                                            [min]="minDate"
                                            [matDatepicker]="sA"
                                            [(ngModel)]="row.ExpirationDateSubscription"
                                            (ngModelChange)="singleDateOnChange(row)"
                                            [ngModelOptions]="{ standalone: true }"
                                            name="ExpirationDate"
                                            readonly="true"
                                        />
                                        <mat-datepicker-toggle matSuffix [for]="sA"></mat-datepicker-toggle>
                                        <mat-datepicker #sA></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </mat-checkbox>
                    </td>
                </ng-template>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsAccounts"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumnsAccounts"
                class="pointer"
                [ngClass]="row.IsClicked ? 'bgGreenLight2' : ''"
                (click)="onClickSetAccountName(row)"
            ></tr>
        </table>
    </div>
    <ng-template #noAccountFound>
        <div>
            <table class="mat-table" style="width: 100%; height: 100%">
                <tr class="mat-header-row">
                    <th class="mat-header-cell bgWhiteSmoke">
                        <div>
                            <div>
                                <div>
                                    <span translate>M_SUB_INF_TITLE_TABLE</span>
                                    <span> : {{ model.Description }}</span>
                                </div>
                                <button
                                    mat-flat-button
                                    color="primary"
                                    class="button-icon-text"
                                    matTooltip="{{ 'M_ASSOCIATE_ACCOUNT' | translate }}"
                                    matTooltipClass="tooltip-layout"
                                    (click)="onClickShowAssociateAccount()"
                                    style="padding: 0 20px"
                                >
                                    <mat-icon>add</mat-icon>
                                    <span style="padding: 0.2rem; font-size: 1rem" translate>M_SUB_INF_BTN_ASS</span>
                                </button>
                            </div>
                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                    width: 100%;
                                    align-items: center;
                                    padding-bottom: 1.2rem;
                                "
                            >
                                <div class="searchFolder" style="width: 35%">
                                    <div style="display: flex; width: 100%">
                                        <mat-icon matPrefix [inline]="true" class="m-r5" style="width: 5%"> search </mat-icon>
                                        <input
                                            matInput
                                            [(ngModel)]="searchAccountText"
                                            (keyup)="onClickApplyAccountSearch($event)"
                                            placeholder="{{ 'M_SEARCH_ACC' | translate }}"
                                        />
                                    </div>
                                    <div>
                                        <mat-icon matSuffix [inline]="true" (click)="clearAccountSearch()"> close </mat-icon>
                                    </div>
                                </div>
                                <div class="searchFolder" style="padding: 0 20px; width: 18%" *ngIf="showFilterOptions">
                                    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
                                        <div style="width: 100%">
                                            <mat-label translate>SUBSCRIPTIONS_ACCOUNTS.FILTER_BY </mat-label>
                                        </div>
                                        <div style="display: flex">
                                            <span class="material-icons"> filter_alt </span>
                                            <mat-select (selectionChange)="onClickDoSomething($event)">
                                                <mat-option value="ALL"><span translate>MANAGE_ACCOUNTS.OPT_1</span> </mat-option>
                                                <mat-option value="CO-USER-ADMIN"
                                                    ><span translate>ROLES_STRINGS.COUSERADMIN</span>
                                                </mat-option>
                                                <mat-option value="USER-ADMIN"><span translate>ROLES_STRINGS.USERADMIN </span> </mat-option>
                                                <mat-option value="POWER-USER"><span translate>ROLES_STRINGS.POWERUSER</span> </mat-option>
                                                <mat-option value="POWER-USER-SCHEDULER"
                                                    ><span translate>ROLES_STRINGS.POWERUSERSCHED </span>
                                                </mat-option>
                                                <mat-option value="POWER-USER-REPORT"
                                                    ><span translate>ROLES_STRINGS.POWERUSERREPORT </span>
                                                </mat-option>
                                                <mat-option value="SECURITY-ADMIN"
                                                    ><span translate>ROLES_STRINGS.SECURITYADMIN</span>
                                                </mat-option>
                                                <mat-option value="APPLICATION-ADMIN"
                                                    ><span translate> ROLES_STRINGS.APPLICADMIN</span>
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </th>
                </tr>
                <tr class="mat-row">
                    <td class="mat-cell">
                        <span translate>M_ACC_NOT_FOUND</span>
                    </td>
                </tr>
            </table>
        </div>
    </ng-template>
</div>
